import React from "react";

const UnitCountEight = ({ totalSummary }) => {
  // console.log("UnitCountEight", totalSummary);
  const { totalAppointments,
    totalBookedSnb,
    totalBookedSdt,
    totalPackagePrice,
    totalReceivedAmount,
    totalDiscount } = totalSummary || {};


  return (
    <div className='row gy-4 mb-3'>
      <div className='col-xxl-2 col-sm-6'>
        <div className='card p-3 shadow-2 radius-8 h-100 gradient-deep-two-1 border border-white'>
          <div className='card-body p-0'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
              <div className='d-flex align-items-center gap-10'>
                <span className='mb-0 w-48-px h-48-px bg-cyan-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0'>
                  <img
                    src='assets/images/home-eleven/icons/home-eleven-icon1.svg'
                    alt=''
                  />
                </span>
                <div>
                  <span className='fw-medium text-secondary-light text-md'>
                    Total Appointments
                  </span>
                  <h6 className='fw-semibold mt-2'>{totalAppointments}</h6>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='col-xxl-2 col-sm-6'>
        <div className='card p-3 shadow-2 radius-8 h-100 gradient-deep-two-2 border border-white'>
          <div className='card-body p-0'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
              <div className='d-flex align-items-center gap-10'>
                <span className='mb-0 w-48-px h-48-px bg-warning-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0'>
                  <img
                    src='assets/images/home-eleven/icons/home-eleven-icon2.svg'
                    alt=''
                  />
                </span>
                <div>
                  <span className='fw-medium text-secondary-light text-md'>
                    Booked SDT
                  </span>
                  <h6 className='fw-semibold mt-2'>{totalBookedSnb}</h6>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='col-xxl-2 col-sm-6'>
        <div className='card p-3 shadow-2 radius-8 h-100 gradient-deep-two-3 border border-white'>
          <div className='card-body p-0'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
              <div className='d-flex align-items-center gap-10'>
                <span className='mb-0 w-48-px h-48-px bg-lilac-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0'>
                  <img
                    src='assets/images/home-eleven/icons/home-eleven-icon3.svg'
                    alt=''
                  />
                </span>
                <div>
                  <span className='fw-medium text-secondary-light text-md'>
                    Booked SNB

                  </span>
                  <h6 className='fw-semibold mt-2'>{totalBookedSdt}</h6>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='col-xxl-2 col-sm-6'>
        <div className='card p-3 shadow-2 radius-8 h-100 gradient-deep-two-4 border border-white'>
          <div className='card-body p-0'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
              <div className='d-flex align-items-center gap-10'>
                <span className='mb-0 w-48-px h-48-px bg-success-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0'>
                  <img
                    src='assets/images/home-eleven/icons/home-eleven-icon2.svg'
                    alt=''
                  />
                </span>
                <div>
                  <span className='fw-medium text-secondary-light text-md'>
                    Package Price
                  </span>
                  <h6 className='fw-semibold mt-2'>₹{totalPackagePrice}</h6>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='col-xxl-2 col-sm-6'>
        <div className='card p-3 shadow-2 radius-8 h-100 bg-gradient-end-3 border border-white'>
          <div className='card-body p-0'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
              <div className='d-flex align-items-center gap-10'>
                <span className='mb-0 w-48-px h-48-px bg-success-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0'>
                  <img
                    src='assets/images/home-eleven/icons/home-eleven-icon4.svg'
                    alt=''
                  />
                </span>
                <div>
                  <span className='fw-medium text-secondary-light text-md'>
                    Received Amount
                  </span>
                  <h6 className='fw-semibold mt-2'>₹{totalReceivedAmount}
                  </h6>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='col-xxl-2 col-sm-6'>
        <div className='card p-3 shadow-2 radius-8 h-100 bg-gradient-end-2 border border-white'>
          <div className='card-body p-0'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8'>
              <div className='d-flex align-items-center gap-10'>
                <span className='mb-0 w-48-px h-48-px bg-success-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0'>
                  <img
                    src='assets/images/home-eleven/icons/home-eleven-icon4.svg'
                    alt=''
                  />
                </span>
                <div>
                  <span className='fw-medium text-secondary-light text-md'>
                    Total Discount
                  </span>
                  <h6 className='fw-semibold mt-2'>₹{totalDiscount}</h6>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitCountEight;
